export const TOOLTIP_MARGIN_OFFSET = 10;